module.exports = __webpack_public_path__ + "img/fontsForEngravings@2x.c332224.jpg";